const config = {
    MAX_PARALLEL_IMAGE_REQUESTS: 16,
    REGISTERED_PROTOCOLS: {},
};
export default config;
//# sourceMappingURL=config.js.map